module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("stats stats--" + _vm.alignClass)
  }, _vm._l((_vm.items), function(item) {
    return _c('figure', {
      class: ("stat-item stat-item--" + (_vm.toCssName(item.stat_type)))
    }, [_c('header', {
      staticClass: "stat-item__header"
    }, [_c('span', {
      staticClass: "stat-item__number"
    }, [_vm._v(_vm._s(item.number_1))]), _vm._v(" "), (item.stat_type === 'Fraction') ? [_c('span', {
      staticClass: "stat-item__symbol"
    }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
      staticClass: "stat-item__number"
    }, [_vm._v(_vm._s(item.number_2))])] : _vm._e(), _vm._v(" "), (item.stat_type === 'Percentage') ? [_c('span', {
      staticClass: "stat-item__symbol"
    }, [_vm._v("%")])] : _vm._e()], 2), _vm._v(" "), _c('figcaption', {
      staticClass: "stat-item__contents"
    }, [(item.statistic_text) ? _c('div', {
      staticClass: "stat-item__text",
      domProps: {
        "innerHTML": _vm._s(_vm.getHtmlContent(item.statistic_text))
      }
    }) : _vm._e(), _vm._v(" "), (item.source) ? _c('div', {
      staticClass: "stat-item__source",
      domProps: {
        "innerHTML": _vm._s(item.source)
      }
    }) : _vm._e()])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10b7904c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Stats.vue
// module id = 71
// module chunks = 0